var map = {
	"./bear.svg": 336,
	"./bird.svg": 337,
	"./camel.svg": 338,
	"./cat.svg": 339,
	"./chicken.svg": 340,
	"./cow.svg": 341,
	"./dog.svg": 342,
	"./dolphin.svg": 343,
	"./dove.svg": 344,
	"./duck.svg": 345,
	"./elephant.svg": 346,
	"./frog.svg": 347,
	"./goat.svg": 348,
	"./goose.svg": 349,
	"./hamster.svg": 350,
	"./horse.svg": 351,
	"./lion.svg": 352,
	"./macaw.svg": 353,
	"./monkey.svg": 354,
	"./mouse.svg": 355,
	"./owl.svg": 356,
	"./pig.svg": 357,
	"./rooster.svg": 358,
	"./sheep.svg": 359,
	"./snake.svg": 360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 335;